import { Logo } from "./Logo";
import { CONTACT, NAV } from "../data/content";
import { scrollToId } from "../hooks/useLenis";

export const Footer = () => (
  <footer className="relative bg-forest text-white overflow-hidden grain" data-testid="footer">
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-20 pb-10">
      <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
        <div className="md:col-span-5">
          <Logo light size={52} />
          <p className="mt-6 text-white/60 text-sm leading-relaxed max-w-sm">Pour une santé et sécurité au travail durables en Afrique et au-delà.</p>
        </div>
        <div className="md:col-span-3">
          <div className="font-accent text-xs tracking-[0.3em] uppercase text-gold">Navigation</div>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.id}><button onClick={() => scrollToId(n.id)} data-testid={`footer-link-${n.id}`} className="text-white/75 hover:text-white hover:translate-x-1 inline-block transition-[color,transform] text-sm font-semibold">{n.label}</button></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="font-accent text-xs tracking-[0.3em] uppercase text-gold">Contact</div>
          <ul className="mt-5 space-y-3 text-sm text-white/75">
            <li><a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors" data-testid="footer-email">{CONTACT.email}</a></li>
            <li><a href={`tel:${CONTACT.phone}`} className="hover:text-white transition-colors" data-testid="footer-phone">{CONTACT.phoneDisplay}</a></li>
            <li><a href={CONTACT.websiteUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-website">{CONTACT.website}</a></li>
            <li>{CONTACT.address}</li>
          </ul>
        </div>
      </div>

      <div className="relative mt-10">
        <div className="font-heading font-black text-[16vw] leading-[0.8] tracking-tighter text-white/[0.06] select-none pointer-events-none text-center" aria-hidden>RISQZERO</div>
        <div className="absolute inset-x-0 bottom-0 flex flex-col sm:flex-row items-center justify-between gap-3 text-[0.7rem] uppercase tracking-[0.2em] text-white/40">
          <span>© 2026 RisQZero · Abidjan · {CONTACT.website}</span>
          <span className="text-gold">de la Qualité à Zéro accident</span>
        </div>
      </div>
    </div>
  </footer>
);
